var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthorCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5.5,
    r: 3.5,
    fill: "#3AFCC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 1.32089L6 0.00439453L2.028 1.32089C1.72874 1.4201 1.46834 1.61108 1.2838 1.86671C1.09926 2.12234 0.999959 2.42961 1 2.74489V5.99988C1 9.76188 5.6 11.8394 5.797 11.9259L5.974 12.0044L6.158 11.9434C6.356 11.8774 11 10.2884 11 5.99988V2.74489C11 2.42961 10.9007 2.12234 10.7162 1.86671C10.5317 1.61108 10.2713 1.4201 9.972 1.32089ZM6.222 6.99438C6.13459 7.08237 6.03058 7.15213 5.91599 7.19959C5.8014 7.24706 5.67853 7.27129 5.5545 7.27088H5.538C5.41145 7.26894 5.2866 7.24136 5.17101 7.18979C5.05542 7.13823 4.95149 7.06376 4.8655 6.97088L3.7125 5.77088L4.434 5.07989L5.556 6.24988L8.1465 3.65939L8.8535 4.36639L6.222 6.99438Z",
    fill: "#7759F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorCheck);
export default __webpack_public_path__ + "static/media/author-check.d9784b38d93cbe86d271063c8488a651.svg";
export { ForwardRef as ReactComponent };